<template>
  <div class="basicLayout" :class="$flag?'mobile_layout':'pc_layout'">
    <el-container class="container" style="overflow-x:hidden;width:100%;box-sizing:border-box">
      <!-- <el-header class="header clearfixed text-white" style="display: flex; justify-content: space-between;">
        <div class="pull-left flex a-center" style="flex: 1;">
            <div class="logo cursor-pointer"
            @click="$router.push('/index/index')"
          >
            <img
              v-if="ruleForm.company_logo"
              style="display:inline-block;height:40px;max-width:240px"
              class="h-40"
              :src="$host.file+ruleForm.company_logo"
              alt
            />
            <img v-else class="h-40" src="../assets/images/logo.png" alt />
            <span
              class="text-white m-hide"
              style="font-weight:500;margin-left:10px;font-size: 20px;letter-spacing: 2px;"
            >
              <span v-if="ruleForm.company_name">{{ruleForm.company_name}}</span>
              <span>{{$t('yhzxglzx')}}</span>
            </span>
          </div>
          <div class="dashboard fs-14">
          </div>
        </div>

      </el-header> -->
      <el-container class="o-hidden">
        <!-- 左边主菜单 -->
        <el-aside v-if="hide_menu==0"  class="aside user-center-aside" :style="'width:'+($flag?'100%':'260px')+' !important'">
          <div class="top-container" style="text-align: center">
            <img class="logo" @click="go()" src="@/assets/icon/logo.png" alt="">
<!--			 <img class="avatar" :src="$tool.src(userInfo.head)" alt="">-->
            <el-avatar :src="$tool.src(userInfo.head)" :size="60"></el-avatar>
           <!-- <img class="avatar" :src="$host.file+userInfo.head" alt=""> -->
            <div class="user-name">
              <span class="name">{{userInfo.nick}}</span>
              <span class="logout" @click="logout()">{{$t('layout_exit')}}</span>
            </div>
          </div>
          <side-menu />
		  <!--二维码-->
		   <div class="ewm-box">
			   <img  :src="$host.file + Android_code" width="110" />
			   <div class="ewm-text">
           {{$t('azxz')}}
			   </div>
			   
			   <img style="margin-top:10px;"  class="ewm-img-tow" :src="$host.file + ios_code"  width="110" />
			   <div class="ewm-text ewm-text-tow">
           {{$t('pgxz')}}
			   </div>
		   </div>
        </el-aside>
      
        <el-main v-if="!$flag" class="main  user-center-main">
          <div class="content o-y-scroll">
            <div class="top-right-operate-container">
              <div class="left">
                <span
                  class="text-white m-hide"
                  style="font-weight:500;margin-left:10px;font-size: 20px;letter-spacing: 2px;"
                >
                  <span v-if="ruleForm.company_name">{{ruleForm.company_name}}</span>
                  <span>{{$t('yhzxglzx')}}</span>
                </span>
              </div>
              <div class="right">
                <!-- <span
                  style="margin-right:10px;cursor:pointer;"
                  @click="$router.push('/index/index')"
                  class="m-hide"
                >{{$t('user_WEb_SY')}}</span> -->
                <a href="/index/index"><img style="margin-right:10px;cursor:pointer;width: 24px;" src="@/assets/images/home-icon.png" alt=""></a>
                <!-- <div @click="openChat('',1)" class="cursor-pointer m-r-10 m-hide">
                  <el-badge
                    v-if="countMessage"
                    :value="countMessage"
                    class="item"
                    type="primary"
                    style="line-height: 34px;"
                  >
                    <i class="el-icon-s-comment fz-18 text-white"></i>
                  </el-badge>
                  <i v-else class="el-icon-s-comment fz-18"></i>
                </div> -->
                <!-- <el-dropdown
                  v-if="userInfo.role == 2"
                  style="margin-right:10px;vertical-align: super;height: 62px;"
                  @command="handleCommand1"
                  trigger="click"
                >
                  <span class="el-dropdown-link fs-14 text-white cursor-pointer">
                    {{workStatus}}
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="1">{{$t('workOn')}}</el-dropdown-item>
                    <el-dropdown-item command="2">{{$t('workOff')}}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown> -->
                <div class="m-hide">
                  <!--<span class="cursor-pointer" @click="handleCommand('zh')">{{$t('Chinese')}}</span> |
                  <span class="cursor-pointer" @click="handleCommand('en')">English</span>-->
                  <span class="cursor-pointer">
                     {{selCheck}}</span>  |
                  <span class="cursor-pointer"  @mouseover="showLang = true">{{$t('qx_lang_bnt')}}</span>
                </div>
                <!-- <el-dropdown size="medium">
                  <div>
                    <el-avatar
                      style="vertical-align: middle;"
                      :size="30"
                      class="m-r-10"
                    >
                      <img style="width:30px;" :src="$host.file+userInfo.head" />
                    </el-avatar>
                    <span
                      class="el-dropdown-link fs-14 text-white cursor-pointer"
                    >{{userInfo ? userInfo.nick : ''}}</span>
                  </div>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="goInfoCenter()">{{$t('user_WEb_SY')}}</el-dropdown-item>
                    <el-dropdown-item @click.native="logout()">{{$t('layout_exit')}}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown> -->
              </div>

            </div>
            <!-- <sub-menu /> -->
            <!-- <transition name="fade" mode="out-in"> -->
              <div class="right-content">
                <router-view />
              </div>

            <!-- </transition> -->
          </div>
        </el-main>
        <!--个人信息手机端-->
        <div v-else class="ucenter-box">
            <template v-if="hide_menu==1">
              <router-view />
            </template>

        </div>



      </el-container>
      <!-- <chatGroup  /> -->
    </el-container>

<div class="chat-box-v" @click="openChat2()">
	   <div class="new-msg-box" :style="'display:'+(countMessage>0?'block':'none')" id="new_msg_count">{{countMessage}}</div>
         <img src="../assets/images/chat-v.png" alt />
       
    </div>

   <!-- <div class="chat-box-v" @click="openChat2()">
		<div class="new-msg-box" id="new_msg_count"></div>
      <el-badge :value="countMessage2" class="item" v-if="countMessage2">
        <img src="../assets/images/chat-v.png" alt />
       
      </el-badge>
      <template v-else>
        <img src="../assets/images/chat-v.png" alt />
        
      </template>
    </div>-->



    <el-dialog
        :title="$t('qx_lang')"
        :visible.sync="showLang"
        width="40%"
    >
      <div>

        <el-row>
          <el-col style="margin-bottom:8px" v-for="(item,index) in lang_list" :key="index" :span="6">
             <span @click="setLang(item)"  class="lang-bnt">
                <img :src="$tool.src(item.flag)" />
               {{item.name}}</span>
          </el-col>

        </el-row>

      </div>

    </el-dialog>


	 <Im></Im>
  </div>
</template>

<script>
import SideMenu from "@/components/SideMenu.vue";
import Im from "@/components/Im.vue";
import { mapState } from "vuex";
import { get_company_info } from "@/api/account.js";
import { queryTest, logout, switch_set } from "@/api/user";
import { unreadMessage } from "@/api/chat"; //聊天
import { messageCount } from "@/api/chat";
import { service } from "@/api/login.js";
import cookie from "js-cookie";
export default {
  name: "basicLayout",
  components: {
    SideMenu,
	Im
    // chatGroup
  },
  computed: {
    ...mapState("global", ["countries", "userInfo"])
  },
  data() {
    return {
      lang_list: [{
        type: 'zh',
        name: "中文",
        flag: "/static/flag/CN.png"
      }, {
        type: 'zh-tw',
        name: "中文(繁體)",
        flag: "/static/flag/CN.png"
      },
      {
        type: 'en',
        name: "English",
        flag: "/static/flag/US.png"
      }, {
        type: 'ko-re',
        name: "한국어",
        flag: "/static/flag/KR.png"
      }, {
        type: 'in-do',
        name: "Indonesia",
        flag: "/static/flag/ID.png"
      }, {
        type: 'ja-jp',
        name: "日文",
        flag: "/static/flag/JP.png"
      }, {
        type: 'ru-ru',
        name: "Русский язык",
        flag: "/static/flag/RU.png"
      }, {
        type: 'pt-pt',
        name: "Português",
        flag: "/static/flag/PT.png"
      }, {
        type: 'es-la',
        name: "Español",
        flag: "/static/flag/ES.png"
      }, {
        type: 'it-it',
        name: "Italiano",
        flag: "/static/flag/IT.png"
      }, {
        type: 'fr-fr',
        name: "Français",
        flag: "/static/flag/FR.png"
      }, {
        type: 'de-de',
        name: "Deutsch",
        flag: "/static/flag/DE.png"
      }, {
        type: 'ar-ab',
        name: "بالعربية",
        flag: "/static/flag/AE.png"
      }],
      flag_url: "/static/flag/CN.png",
      showLang:false,
      selCheck: "中文",
      workStatus: "上班",
      ruleForm: {},
      countMessage: 0,
      timer: null,
      notify: null,
      timer2: "",
      countMessage2: 0,
      handlelog:true,
	  Android_code:"",
	  ios_code: "",
      hide_menu:0
    };
  },
  watch: {
    //监听路由地址的改变
    $route:{
      immediate:true,
      handler(){
        // console.log(this.$route,"===route===route===")
        var path=this.$route.path;
        if(this.$flag){
          if(path=="/insp/sindex"||path=="/insp/orderManage"||path=="/user/orderManage"){
              this.hide_menu=1;
          }else{
              this.hide_menu=0;
          }
        }

      }
    }
  },
  created() {
    
    const _this = this
    this.$store.dispatch('global/getCustomer').then(() => {
      _this.Android_code = _this.$store.state.global.KefuInfo.Android_code;
      _this.ios_code = _this.$store.state.global.KefuInfo.ios_code;
    });
	    // this.getService();
    this.$store.dispatch("global/fetchCountries").then(() => {
      // console.log(this.countries)
    });
    this.$store.dispatch("global/getUserinfo")

    // this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
    // this.selCheck = localStorage.getItem("selCheck") || "中文";
    var locale=cookie.get('think_var');
    if(!locale) locale = localStorage.getItem('locale');
    
    
    this.flag_url = "/static/flag/CN.png";
    for(var i in this.lang_list){
      if(this.lang_list[i].type==locale){
        this.flag_url=this.lang_list[i].flag;
        this.selCheck = this.lang_list[i].name;
        break;
      }
    }
    this.getcompanyinfo();
    // 定时请求消息未读
    let that = this;
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    if(userInfo){ //登录时
	this.unreadMessage();
	return;
      this.timer = setInterval(() => {
        if(that.handlelog){ //判断是否已经完成
          that.handlelog = false
          that.unreadMessage();
        }
      }, 10000);
    }else{ //没有登录时
	this.unreadMessage2();
	return;
      this.timer2 = setInterval(() => {
        if(that.handlelog){ //判断是否已经完成
          that.handlelog = false
          that.unreadMessage2();
        }
      }, 10000);
    }
    
   
  },
  destroyed() {
    // 清空定时器
    clearInterval(this.timer);
    this.timer = null;
    clearInterval(this.timer2);
    this.timer2 = null;
  },
  methods: {
    setLang(item){
      this.selCheck=item.name;
      this.flag_url=item.flag;
      cookie.set('think_var', item.type,{ path:'/'})
      localStorage.setItem("locale", item.type);
      this.$i18n.locale = item.type;
      window.location.reload();
    },
	  // async getService() {
	  //   const res = await service();
	  //   let { code, data } = res.data;
	  //   this.Android_code = data.Android_code;
	  //   this.ios_code = data.ios_code;
	  // },
    async unreadMessage2() {
      let userInfo = JSON.parse(localStorage.getItem("userInfo"));
      let res = {};
      if (userInfo) {
        res = await unreadMessage();
      } else {
        res = await messageCount();
      }
      const { code, data, msg } = res.data;
      this.handlelog = true
      if (code == 200) {
        if (data.count && this.countMessage2 != data.count) {
          this.countMessage2 = data.count ? data.count : "";
        }else{
          this.countMessage2 = 0
        }
      }
    },
    openChat2() {
      let userInfo = JSON.parse(localStorage.getItem("userInfo"))
        ? JSON.parse(localStorage.getItem("userInfo"))
        : "";
      let newObj = {};
      if (userInfo) {
        newObj = this.$router.resolve({ path: "/groupchat" });
      } else {
        newObj = this.$router.resolve({ path: "/visitorchat" });
      }
      window.open(newObj.href, "_blank");
    },

    async unreadMessage() {
      const res = await unreadMessage();
      const { code, data, msg } = res.data;
      this.handlelog = true
      if (code == 200) { //该客户是否分配了跟单员  0 - 未分配
          localStorage.setItem('admin_ids',data.admin_id)
        if (data.count && this.countMessage != data.count) {
          this.countMessage = data.count;
          this.countMessage2 = data.count;
          // this.notify = this.$notify.info({
          //   title: "消息",
          //   dangerouslyUseHTMLString: true,
          //   duration: 0, //不会自动关闭
          //   message: `您有${this.countMessage}条未读消息，<a target="_blank" style="color: #61c3ff;" href="/groupchat">前往查看</a>`
          // });
        }else{
          this.countMessage = data.count;
          this.countMessage2 = data.count;
          if(this.notify){
            this.notify.close();
          }
        }
      }
    },
    //获取企业信息
    async getcompanyinfo() {
      const res = await get_company_info();
      const { code, data, msg } = res.data;
      if (code == 200) {
        this.ruleForm = data;
        // if (
        //   this.ruleForm.country == "中国" &&
        //   this.ruleForm.province
        // ) {
        //   this.provinChange();
        // }
      }
    },
    // 跳转到个人中心
    goInfoCenter() {
      // let role = this.userInfo.role
      // let url = ''
      // role == 2 ? url = '/insp/index' : url = '/user/index'
      this.$router.push("/index/index");
    },
    // 上下班状态切换
    async handleCommand1(e) {
      this.workStatus = e == 1 ? "上班" : "下班";
      const res = await switch_set({
        name: "work_status",
        value: e
      });
      const { data, code, msg } = res.data;
      if (code == 200) {
        this.$message.success(msg);
      }
    },
    handleCommand(e) {
      console.log("切换中英文")
      this.selCheck = e == "zh" ? "中文" : "English";
      localStorage.setItem("selCheck", this.selCheck);
      localStorage.setItem("locale", e);
      this.$i18n.locale = e;
      window.location.reload();
    },
	go(){
	    location.href="/"; 
	},
    logout() {
      const _this = this
      this.$confirm('是否退出?', '提示', {
        confirmButtonText: _this.$t('user_Index_QR'),
        cancelButtonText: _this.$t('pay_qx'),
        type: 'warning'
      }).then(() => {

        logout().then(res => {
          console.log(res)
          if (res.data.code == 200) {
			  //mydev
			  cookie.remove("auto_token");
            _this.$message.success(_this.$t("layout_exitSuccess"));
            localStorage.removeItem("USERToken");
            localStorage.removeItem("userInfo");
            _this.$store.commit("global/set_userInfo", "");
            localStorage.removeItem("locale");
            localStorage.removeItem("selCheck");
            localStorage.removeItem("role");
            localStorage.removeItem("shareCode");
            localStorage.removeItem("im_token");
            window.location.href = "/index/index"
            // _this.$router.push("/index/index");
          }
        });
      }).catch(() => {
        _this.$message({
          type: 'info',
          message: '已取消'
        });          
      });
    }
  }
};
</script>
<style lang="scss" scoped>
ul,
li,
ol {
  list-style-type: none;
}
$header-height-important: 60px !important;
.basicLayout {
  width: 100%;
  height: 100%;
}
.container {
  height: 100%;
  position: relative;
  .header {
    background-color: $--color-primary;
    height: $header-height-important;
    line-height: $header-height-important;
    border-bottom: 1px solid $--color-primary;
  }
  .aside {
    position: fixed;
    width: 260px!important;
    height: 100vh;
    // overflow-y: scroll;
    
    background-color: #242A37;
    .top-container {
      width: 100%;
      box-sizing: border-box;
      padding: 13px 29px;
      border-bottom: 1px solid #41495B;
      .logo {
        width: 200px;
      }
      .avatar {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        margin: 27px auto 20px auto;
      }
      .user-name {
        font-size: 20px;
        color: #FFFFFF;
        text-align: center;
        .name {
          padding-right: 10px;
        }
        .logout {
          cursor: pointer;
          font-size: 12px;
          color: #FF5023;
          padding-left: 10px;
          border-left: 1px solid #7a7575;
        }

      }
    }
  }
  .main {
    margin-left: 260px;
    width: calc(100vw - 260px);
    display: flex;
    flex-direction: column;
    padding: 0px;
    box-sizing: border-box;
    .top-right-operate-container {
      // background-color: pink;
      background: #FFFFFF;
      box-shadow: 0px 3px 4px 0px rgba(0,0,0,0.06);
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 70px;
      padding: 0 8px 0 20px;
      .right {
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }
    }
    .right-content {
      margin-left: 20px;
      min-height: calc(100vh - 90px);
    }
    .content {
      background: #EEF1F6;
      flex: 1;
      // height: 100vh;
      // max-height: 100vh;
      // overflow-y: hidden;
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
/deep/ .el-badge__content {
  background-color: #37aee7;
}
@media screen and (max-width: 720px) {
  .container {
    .header {
      padding: 0 0 0 0;
    }
  }
  .m-hide{
    display: none;
  }
}
.ewm-box{
	width:140px;
	min-height:200px;
	text-align:center;
	margin:35px auto;
	color:#fff;
	font-size:14px;
	.ewm-text{
		padding:10px 0;
	}
}

.new-msg-box{
	position:absolute;
	background:#f00;
	color:#fff;
	width:20px;
	height:20px;
	line-height:18px;
	border-radius:10px;
	text-align:center;
	font-size:10px;
	left:10px;
	top:-15px;
	display:none;
	border:2px solid #fff;
}
.lang-bnt{
  cursor:pointer;
}
</style>